import React from "react";

import Styles from "./layout.module.scss";

export const Page = ({ children }) => {
    return (
        <div className={Styles.pageOuter}>
            <div className={Styles.pageInner}>
                {children}
            </div>
        </div>
    );
}

export const TileContainer = ({ children }) => {
    return (
        <div className={Styles.tileContainer}>{children}</div>
    );
}

// TODO: better sizing system
export const Tile = ({ children }) => {
    return (
        <div className={Styles.tileOuter}>
            <div className={Styles.tileInner}>
                {children}
            </div>
        </div>
    );
}

export const Card = ({ children }) => {
    return (
        <div className={Styles.cardOuter}>
            <div className={Styles.cardInner}>
                {children}
            </div>
        </div>
    )
}


export const Form = (props) => {
    return (
        <form className={Styles.form} {...props}>
            {props.children}
        </form>
    )
}

export const FormRow = ({ children }) => {
    return (
        <div className={Styles.formRow}>
            {children}
        </div>
    )
}

export const CenterForm = ({ children }) => {
    return (
        <div className={Styles.centerForm}>
            {children}
        </div>
    )
}

export default {
    Page,
    TileContainer,
    Tile,
    Card,
    Form,
    FormRow,
    CenterForm,
}



// WEBPACK FOOTER //
// ./src/components/layout/layout.js